export enum ResultStatus {
    Success = "200",
    UnAuthorized = "401",
}